import { Input, InputProps } from 'antd';
import React from 'react';

// Search Input Component
interface SearchInputProps extends InputProps {
  onSearch?: (value: string, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({ placeholder = 'Cauta...', onSearch, style, ...props }) => {
  return (
    <Input.Search
      placeholder={placeholder}
      allowClear
      style={{ float: 'right', width: '60%', ...style }}
      {...props}
      autoFocus={true}
      className='search'
    />
  );
};
